/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Transfer_CodeInputs */

const vi_order_transfer_code = /** @type {(inputs: Order_Transfer_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã CK`)
};

/**

* @param {Order_Transfer_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_transfer_code = /** @type {((inputs?: Order_Transfer_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Transfer_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_transfer_code(inputs)
});